import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS002KeiyakuInfoInVO,} from '@pages/sms002-keiyaku-info/sms002-keiyaku-info-in-vo';
import {SMS002KeiyakuInfoOutVO,} from '@pages/sms002-keiyaku-info/sms002-keiyaku-info-out-vo';
import * as Const_SMS002 from '@pages/sms002-keiyaku-info/sms002-keiyaku-info-const';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms002-keiyaku-info',
  templateUrl: './sms002-keiyaku-info.html',
  styleUrls: ['./sms002-keiyaku-info.scss',],
})
/*****************************************************/
/* 処　理：SMS002 契約情報 画面
/*
/* 概　要：契約情報確認 処理
/*
/* 更新日：2025/03/06 HARAGU 00011_SMS機能等の導入支援_#10081
/*****************************************************/
export class SMS002KeiyakuInfo implements OnInit {
  smsForm!: FormGroup;                  // 画面フォーム
  loginUserVO!: LoginUserVO;            // セッション情報
  sms002InfoVO!: SMS002KeiyakuInfoInVO; // POSTパラメータ
  dispId!: string;                      // ログ表示用ID
  lngType!: string;                     // 言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // 画面項目（ラベル入れ替え用）
  public lblAddress01!: string;
  public lblTelephone01!: string;
  public lblTelephone02!: string;
  public lblMessage01!: string;
  public lblNameSei!: string;
  public lblNameMei!: string;
  public lblKanaSei!: string;
  public lblKanaMei!: string;
  public lblBirthday!: string;
  public lblBldgName!: string;
  public lblRoomNo!: string;
  public lblKeiyakuDate!: string;
  public lblBtnSend!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
          && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
          && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {
      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00201M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }

    const postVo: SMS002KeiyakuInfoInVO = this.windowService.getItemFromLocalStorage<SMS002KeiyakuInfoInVO>('SMS002')!;
    if (postVo) {
      // POSTパラメータを取得
      this.sms002InfoVO = postVo;

    } else {

      // エラーログ出力
      this.logger.error('SMS00201M006E');

      // POSTパラメータが取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      txtNameSei: ['',],
      txtNameMei: ['',],
      txtKanaSei: ['',],
      txtKanaMei: ['',],
      txtBirthday: ['',],
      txtBldgName: ['',],
      txtRoomNo: ['',],
      txtKeiyakuDate: ['',],
    });

    // 初期表示
    this.formInit();
  }

  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00201M001I', this.dispId, Const_SMS002.INIT_NAME);

      // ログ出力（セッション情報）
      this.logger.debug(this.dispId + ' ■ 02 Sesion情報');
      this.logger.debug(this.dispId + ' ■ 02  hashId        ：' + this.loginUserVO.hashId);
      this.logger.debug(this.dispId + ' ■ 02  languageType  ：' + this.loginUserVO.languageType);
      this.logger.debug(this.dispId + ' ■ 02  menuNo        ：' + this.loginUserVO.menuNo);
      this.logger.debug(this.dispId + ' ■ 02  keiyakuInfoId ：' + this.loginUserVO.keiyakuInfoId);
      this.logger.debug(this.dispId + ' ■ 02  shouninNo     ：' + this.loginUserVO.shouninNo);

      // ログ出力（POSTパラメータ）
      this.logger.debug(this.dispId + ' ■ 02 POSTパラメータ');
      this.logger.debug(this.dispId + ' ■ 02  screenId      ：' + this.sms002InfoVO.screenId);

      // 初期表示API処理
      this.getInitData(Const_SMS002.API_INIT_PATH, Const_SMS002.INIT_NAME);

      // テキストボックス制御
      this.smsForm.controls['txtNameSei'].disable();
      this.smsForm.controls['txtNameMei'].disable();
      this.smsForm.controls['txtKanaSei'].disable();
      this.smsForm.controls['txtKanaMei'].disable();
      this.smsForm.controls['txtBirthday'].disable();
      this.smsForm.controls['txtBldgName'].disable();
      this.smsForm.controls['txtRoomNo'].disable();
      this.smsForm.controls['txtKeiyakuDate'].disable();

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00201M002I', this.dispId, Const_SMS002.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00201M001E', this.dispId, Const_SMS002.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 02 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 02 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 02 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 02 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00201M003I', this.dispId, btnName);
    this.httpClient.post<SMS002KeiyakuInfoOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00201M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00201M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00201M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 02 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS002KeiyakuInfoOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS002KeiyakuInfoOutVO): void {

    this.logger.debug(this.dispId + ' ■ 02 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  sei        ：' + resp['sei']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  mei        ：' + resp['mei']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  seiKana    ：' + resp['seiKana']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  meiKana    ：' + resp['meiKana']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  birthday   ：' + resp['birthday']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  bldgName   ：' + resp['bldgName']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  roomNo     ：' + resp['roomNo']);
    this.logger.debug(this.dispId + ' ■ 02 ApiOut  keiyakuDate：' + resp['keiyakuDate']);

    // 生年月日
    const bYY = resp['birthday'].substring(0, 4);
    const bMM = resp['birthday'].substring(4, 6);
    const bDD = resp['birthday'].substring(6, 8);
    const birthday = bYY + '/' + bMM + '/' + bDD
    // 契約日
    const kYY = resp['keiyakuDate'].substring(0, 4);
    const kMM = resp['keiyakuDate'].substring(4, 6);
    const kDD = resp['keiyakuDate'].substring(6, 8);
    const keiyakuDate = kYY + '/' + kMM + '/' + kDD

    // テキストボックス設定
    this.smsForm.get('txtNameSei')?.setValue(resp['sei']);
    this.smsForm.get('txtNameMei')?.setValue(resp['mei']);
    this.smsForm.get('txtKanaSei')?.setValue(resp['seiKana']);
    this.smsForm.get('txtKanaMei')?.setValue(resp['meiKana']);
    this.smsForm.get('txtBirthday')?.setValue(birthday);
    this.smsForm.get('txtBldgName')?.setValue(resp['bldgName']);
    this.smsForm.get('txtRoomNo')?.setValue(resp['roomNo']);
    this.smsForm.get('txtKeiyakuDate')?.setValue(keiyakuDate);

    // 画面文言（言語区分により変換）
    // OFI住所
    this.lblAddress01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001F',},  false) || '';
    // Tel：0570-030-660
    this.lblTelephone01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M002F',},  false) || '';
    this.lblTelephone02 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M003F',},  false) || '';

    // こちらでお間違いないですか。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M001F',},  false) || '';
    // 氏名 姓
    this.lblNameSei = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M002F',},  false) || '';
    // 名
    this.lblNameMei = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M003F',},  false) || '';
    // 氏名 セイ
    this.lblKanaSei = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M004F',},  false) || '';
    // メイ
    this.lblKanaMei = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M005F',},  false) || '';
    // 生年月日
    this.lblBirthday = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M006F',},  false) || '';
    // 物件名
    this.lblBldgName = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M007F',},  false) || '';
    // 部屋番号
    this.lblRoomNo = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M008F',},  false) || '';
    // 契約開始日
    this.lblKeiyakuDate = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M009F',},  false) || '';
    // 送信
    this.lblBtnSend = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M010F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M011F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS002' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 02 end---- getInitApiReturnInfo');
    return;
  }

  /* **************************************************************
   * 送信ボタン押下
   * **************************************************************/
  executeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00201M005I', this.dispId, Const_SMS002.BTN_EXECUTE_NAME);

      // 画面遷移
      this.nextPage();

    } catch (ex) {
      this.logger.error('SMS00201M002E', this.dispId, Const_SMS002.BTN_EXECUTE_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面遷移処理
   */
  nextPage(): void{
    // 画面選択
    if ( 'SMS005' === this.sms002InfoVO.screenId) {
      // ■ 家賃残高・口座の確認 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 05 画面遷移');
      this.windowService.transit<null>('SMS005', null);

    } else if ('SMS003' === this.sms002InfoVO.screenId) {
      // ■ 支払日確認登録 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 03 画面遷移');
      this.windowService.transit<null>('SMS003', null);

    } else if ('SMS004' === this.sms002InfoVO.screenId) {
      // ■ バーコード用リンク 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 04 画面遷移');
      this.windowService.transit<null>('SMS004', null);

    } else if ('SMS006' === this.sms002InfoVO.screenId) {
      // ■ 翌月家賃等請求額確認 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 06 画面遷移');
      this.windowService.transit<null>('SMS006', null);

    } else if ('SMS007' === this.sms002InfoVO.screenId) {
      // ■ 解約・退去の登録 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 07 画面遷移');
      this.windowService.transit<null>('SMS007', null);

    } else if ('SMS009' === this.sms002InfoVO.screenId) {
      // ■ 氏名変更 画面へ
      this.logger.debug(this.dispId + ' ■ 02 → 09 画面遷移');
      this.windowService.transit<null>('SMS009', null);

    } else if ('netkouza' === this.sms002InfoVO.screenId) {
      // ■ 外部URL（ネット口座振替受付サービス）
      this.logger.debug(this.dispId + ' ■ 02 → 外部：ネット口座振替受付サービス');
      this.externalPage();
    }
  }

  /**
   * 外部サイトへ遷移
   */
  externalPage():void {
    window.location.href = Const_SMS002.URL_NETKOUZA;
  }


  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00201M005I', this.dispId, Const_SMS002.BTN_BACKMENU_NAME);

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00201M002E', this.dispId, Const_SMS002.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }


  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 02 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

}
